<template>
  <div>
    <van-nav-bar
      title="提现"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
    >
      <template #right>
        <!-- <van-icon name="wechat" size="25" @click="openQchat()" /> -->
        <!-- <van-image
          width="28px"
          height="22px"
          :src="require('../assets/images/chatbar.png')"
          @click="openQchat()"
        /> -->
        <span @click="openQchat()" class="chatTextDesign">在线客服</span>
      </template>
    </van-nav-bar>
    <van-form @submit="getAccountbank">
      <van-row class="rowStyle">
        <van-col span="5" style="line-height: 30px"
          ><span>当前余额:</span></van-col
        >
        <van-col span="9" style="text-align: left; line-height: 30px"
          ><span>{{ cash }}元</span>
        </van-col>
        <van-col span="10" style="text-align: right"
          ><router-link to="information/withdrawal_pass"
            ><van-button
              type="info"
              style="
                height: 32px;
                padding: 0 15px;
                font-size: 14px;
                border-radius: 25px;
              "
              >修改提现密码</van-button
            ></router-link
          ></van-col
        >
      </van-row>
      <van-field
        v-model="money"
        type="digit"
        label="提现金额"
        placeholder="请输入提现金额"
        input-align="right"
        style="color: #000000"
      />
      <van-field
        v-model="password"
        type="password"
        label="提现密码"
        placeholder="请输入提现密码"
        input-align="right"
        style="color: #000000"
      />
      <van-button size="normal" type="danger" block
        >确认提现</van-button
      >
      <!-- <van-row
        v-if="withdraw_fee_percentage == 0 && withdraw_fee_min == 0"
        class="rowStyle"
        style="border-bottom: none"
      >
      </van-row>
      <van-row v-else class="rowStyle" style="border-bottom: none">
        <van-col span="24" style="line-height: 25px"
          ><p style="color: red; margin: 0">温馨提醒：</p>
          <p style="margin: 0">
            提现手续费按提现金额的{{ withdraw_fee_percentage }}%收取，{{
              withdraw_fee_min
            }}元起。
          </p></van-col
        >
      </van-row> -->
    </van-form>
    <!-- ============================== Start change channel popup ========================== -->
    <div style="padding: 10px 16px; font-size: 13px" v-html="data"></div>

    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import CommonLoading from "./CommonLoading";
export default {
  name: "Withdrawal",
  components: {
    CommonLoading,
  },
  data() {
    return {
      cash: 0,
      money: "",
      password: "",
      popupStatus: "",
      timbaoAnulaizedInterestRate: "",
      timebaoRate: "",
      account: "",
      card: "",
      name: "",
      address: "",
      bankStatus: false,
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      withdraw_fee_percentage: 0,
      withdraw_fee_min: 0,
      qserver_url: "",
      data:"",
    };
  },
  methods: {
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url });
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
    get_qchat_server_url() {
      let that = this;
      // that
      //   .$http({
      //     url: "/",
      //     method: "post",
      //     data: {
      //       nozzle: "server_url",
      //     },
      //   })
      //   .then(function (res) {
      //     if (res.data.code == 1) {
      //       var data = res.data.data;
      //       that.qserver_url = data;
            that.$store.commit("chatServerUrl", "");
          // } else if (res.data.code == 0) {
          //   that.$toast.fail(res.data.msg);
          // }
        // });
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getUser() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.cash = resData.data.cash;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    getUserInfo() {
      let that = this;
      // let toast = that.$toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          // toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          if (res.data.code == 1) {
            if (res.data.data.withdrawal == 0) {
              that.showWithdrawlPassPopup();
              return;
            }
            if (res.data.data.bank == 0) {
              that.showWithdrawlBankPopup();
              return;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    getWithdrawChannelInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_channel",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code == 1) {
            that.withdraw_fee_percentage = resData.data.withdraw_fee_percentage;
            that.withdraw_fee_min = resData.data.withdraw_fee_min;
          } else if (res.data.code == 0 || res.data.code == -1) {
            // that.$toast.fail(resData.msg);
          }
        });
    },

    showWithdrawlPassPopup() {
      let that = this;
      Dialog.confirm({
        title: "",
        message: "您还没有设置提现密码，不能提现，请前去设置",
        cancelButtonText: "取消",
        confirmButtonText: "去设置",
      })
        .then(() => {
          that.$router.push({ name: "WithdrawalPass" });
        })
        .catch(() => {
          that.$router.go(-1);
        });
    },
    showWithdrawlBankPopup() {
      let that = this;
      Dialog.confirm({
        title: "",
        message: "请先设置提现银行卡才能提现",
        cancelButtonText: "取消",
        confirmButtonText: "去设置",
      })
        .then(() => {
          that.$router.push({ name: "BindBank" });
        })
        .catch(() => {
          that.$router.go(-1);
        });
    },
    //查询提现是否有银行卡
    getAccountbank() {
      let that = this;
      if (that.money == "") {
        that.$toast.fail("请输入提现金额");
        return false;
      } else if (that.password == "") {
        that.$toast.fail("请输入提现密码");
        return false;
      }
      // let toast = that.$toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "accountbank",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          // toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          let resData = res.data;
          if (res.data.code == 1) {
            if (resData.data.length === 0) {
              that.$toast({
                type: "fail",
                message: "还未绑定银行卡,请前去绑定银行卡才可提现",
                onClose: function () {
                  that.$router.push("/member/information");
                },
              });
            } else {
              that.bankCardList = resData.data;
              that.account = that.bankCardList[0].account;
              that.card = that.bankCardList[0].card;
              that.name = that.bankCardList[0].name;
              that.address = that.bankCardList[0].address;
              that.withdraw_has();
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },

    withdraw_has() {
      let that = this;
      let number = that.money;
      // let toast = that.$toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_has",
            token: sessionStorage.getItem("token"),
            number: number,
          },
        })
        .then(function (res) {
          // toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          let resData = res.data;
          if (resData.code == 0) {
            // that.withdrawal();
            that.WithdrawPopup();
          } else {
            Dialog.confirm({
              title: "",
              message:
                "您已提交一笔同金额的提现正在审核处理中\n若非新提现请勿重复提交 提示",
              cancelButtonText: "非新提现",
              confirmButtonText: "继续新提现",
            })
              .then(() => {
                that.WithdrawPopup();
              })
              .catch(() => {});
          }
        })
        .catch(() => {
          that.withdrawal();
        });
    },

    WithdrawPopup() {
      let that = this;
      // let toast = that.$toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "withdraw_popup",
          },
        })
        .then(function (res) {
          // toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          if (res.data.code == 1) {
            that.popupStatus = res.data.data.is_withdraw_popup;
            that.timbaoAnulaizedInterestRate =
              res.data.data.timebao_annualized_interest_rate;
            that.timebaoRate = res.data.data.timebao_rate;
            that.secondWithdrawalPopup();
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.withdrawal();
        });
    },

    secondWithdrawalPopup() {
      let that = this;
      if (that.popupStatus == 1) {
        Dialog.confirm({
          title: "友情提醒",
          message:
            "转入时时宝, 每8小时收益" +
            that.timebaoRate +
            "%\n开市炒股，休市理财，时时赚钱\n随进随出，实时到账，年化收益率" +
            that.timbaoAnulaizedInterestRate +
            "%",
          cancelButtonText: "转入时时宝",
          confirmButtonText: "继续提现",
          cancelButtonColor: "#ee0a24",
        })
          .then(() => {
            that.withdrawal();
          })
          .catch(() => {
            that.$router.push("/member/time_bao");
          });
      } else {
        that.withdrawal();
      }
    },

    //提现
    withdrawal() {
      let that = this;

      if (that.money == "") {
        that.$toast.fail("请输入提现金额");
        return false;
      } else if (that.password == "") {
        that.$toast.fail("请输入提现密码");
        return false;
      } else {
        // let toast = that.$toast.loading({
        //   forbidClick: true,
        // });
        that.$refs.commonLoader.showCommonLoadigIcon();
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "withdraw",
              token: sessionStorage.getItem("token"),
              number: that.money,
              password: that.password,
              name: that.name,
              card: that.card,
            },
          })
          .then(function (res) {
            // toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            if (res.data.code == 1) {
              that.$toast.success({
                message: "提现成功",
                type: "success",
                onClose: function () {
                  that.$router.push("/member/detailed_log");
                },
              });
            } else if (res.data.code == 2) {
              that.getTradeChannel();
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          })
          .catch(() => {
            that.$toast.fail(that.$NoNetworkErrorMsg);
          });
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      // Toast.loading();
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // Toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            // Toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            // that.$toast.fail(res.data.msg);
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    getData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "information",
            type: 4,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.data=res.data.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    this.get_qchat_server_url();
    this.isLogin();
    this.getUser();
    this.getUserInfo();
    this.getWithdrawChannelInfo();
    this.getData();
  },
};
</script>

<style scoped>
.rowStyle {
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
  font-size: 14px;
}
.chatTextDesign {
  color: #ffffff;
  font-size: 14px;
  padding: 0px 12px;
  border-radius: 6px;
}
</style>

<style>
#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Withdrawal.vue